module.exports = __webpack_public_path__ + "media/metronic/_theme/media/illustrations/data-points-27357f2fbb6f66c0073e29a737ee870e.svg";